export default __webpack_public_path__ + "static/media/page-not-found.c9db8817.png";